import { render, staticRenderFns } from "./emptyProvider.vue?vue&type=template&id=3a3388fa&"
import script from "./emptyProvider.vue?vue&type=script&lang=js&"
export * from "./emptyProvider.vue?vue&type=script&lang=js&"
import style0 from "./emptyProvider.vue?vue&type=style&index=0&id=3a3388fa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports